import React, { useEffect } from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';

// import { Subheader } from 'material-ui';
import { map } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { useDispatch, useSelector } from 'react-redux';
import { shouldNotHide } from 'utils/valuesByKey';

import Loading from '../../components/Loading';
import PanelMessage from '../../components/panels/PanelMessage';
import { fetchProfileIfNeeded } from '../../actions/profile';
import KTitle from '../../components/KJRN/KTitle';
import EmployeeBank from '../../containers/pay/EmployeeBank';
import EmployeeTaxCards from '../../containers/pay/EmployeeTaxCards';

// import cardStyles from '../../containers/pay/styles/Cards';
import KTabs from '../../components/KJRN/KTabs';
import KTab from '../../components/KJRN/KTab';
import Bonuses from '../../containers/pay/Bonuses';
import EmployeePension from '../../containers/pay/EmployeePension';
import EmployeeUnion from '../../containers/pay/EmployeeUnion';
import EmployeePayUnion from '../../containers/pay/EmployeePayUnion';

import './payStyles.css';

const Pay = () => {
  const dispatch = useDispatch();
  const { profileReducer, WebValuesReducer } = useSelector(state => state);

  const {
    employeeDetailOrgListLoaded,
    employeeDetailOrgList,
    masterError,
  } = profileReducer;
  const {
    valuesByKey
  } = WebValuesReducer;
  const show = key => shouldNotHide(valuesByKey, key);

  useEffect(() => {
    dispatch(fetchProfileIfNeeded());
  }, []);

  if (!employeeDetailOrgListLoaded) return <Loading />;

  if (masterError) {
    return (
      <PanelMessage
        message={<FormattedMessage id="time.initialize.error" />}
        iconName="error"
        type="error"
      />
    );
  }

  return (
    <React.Fragment>
      <div>
        <KTitle containerStyle={{ maxWidth: 1400, margin: 'auto', marginTop: 12 }} key="hb" title={<FormattedMessage id="toolbar.payroll" />} />
      </div>
      <Grid>
        <Row>
          <Col xs={12} lg={6} style={{ padding: 16 }}>
            {show('EmployeeMasterBank') && <EmployeeBank />}
            {show('EmployeeMasterTaxCards') && <EmployeeTaxCards />}
          </Col>
          <Col xs={12} lg={6} style={{ padding: 16 }} className="pay-info-desktop">
            {/* <Subheader style={cardStyles.subheader}><FormattedMessage id="career.job" /></Subheader> */}
            <KTabs style={{ marginTop: 12 }}>
              {map(employeeDetailOrgList, (obj, i) => (
                <KTab style={{ padding: 12 }} key={i} name={obj.OrgCompanyPositionName}>
                  {show('EmployeeDetailBasicPay.Bonuses') && <Bonuses detailId={obj.EmployeeDetailID} />}
                  {show('EmployeeDetailPension') && <EmployeePension detailId={obj.EmployeeDetailID} />}
                  {show('EmployeeDetailUnion') && <EmployeePayUnion detailId={obj.EmployeeDetailID} />}
                  {show('EmployeeDetailUnion') && <EmployeeUnion detailId={obj.EmployeeDetailID} />}
                </KTab>
              ))}
            </KTabs>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
};

export default Pay;



// WEBPACK FOOTER //
// ./src/sites/pay/Pay.js